(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["nsm-collection-template"]) return;
  try {
    
  $('.nsm-collection-page-product').on('click', function(e){ 
	window.location.href = $(this).attr('data-href');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsm-list-collections"]) return;
  try {
    
  $('.nsm-list-collections-item').on('click', function(e){ 
	window.location.href = $(this).attr('data-href');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsm-product-template-images"]) return;
  try {
    
  $(document).ready(function(){
    if(bowser.mobile){
      $('.nsm-product-page-images').slick({
        dots: true,
        adaptiveHeight: true
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsm-product-template-reassurance"]) return;
  try {
    
jQuery(document).ready(function($){
    $('.nsm-accordion').each(function(i, accordion){
        var $accordion = $(accordion);
        //if($accordion[0].hasAttribute('data-accordion-inited')) return;
        $accordion.attr('data-accordion-inited', 'true');
        var $titles = $accordion.find('.nsm-accordion-title');
        $titles.next().hide();
	    $titles.click(function(){
	        $(this).next().slideToggle();
	        $titles.not(this).next().stop(true,true).slideUp();
        });
    });
});

  } catch(e) { console.error(e); }
})();

})();
